export function renderGenGetVersionsContentServerActionTemplate({
  ctxSingular,
  ctxPlural
}: {
  ctxSingular: string
  ctxPlural: string
}): string {
  return `'use server'

import { getEntityVersions } from '@admin/actions/entity-versions'
import type { EntityVersionWithAuthor } from '@admin/actions/entity-versions'

export async function getVersionsBy${ctxSingular}Id(
  id: string
): Promise<EntityVersionWithAuthor[]> {
  return getEntityVersions('${ctxPlural}', id)
}
`
}
